import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import {
	getPendingPlatform,
	getPendingToolUrl,
	goToPendingOrFallback,
} from "./continueAfterAuth";

/**
 * HTTPS continuation / browser fallback landing.
 *
 * Route: /pwa/continue
 * Platform is read from pending storage (psl/biz), not from the URL.
 *
 * This is NOT the primary installed-PWA launch mechanism.
 * Open in App uses web+pofsis:// → /pwa/launch on supported desktop Chromium.
 * This page remains for same-origin HTTPS continuation and fallbacks.
 */
export const ContinuePage = () => {
	const platform = getPendingPlatform() || "psl";
	const [message, setMessage] = useState("Opening…");

	useEffect(() => {
		const pending = getPendingToolUrl();
		setMessage(
			pending
				? "Opening your destination…"
				: "No destination saved. Redirecting…"
		);
		goToPendingOrFallback(platform);
	}, [platform]);

	return (
		<Box
			minHeight="100vh"
			display="flex"
			alignItems="center"
			justifyContent="center"
			px={2}
			sx={{
				background:
					"linear-gradient(135deg, #d8f3e8 0%, #f7fbf9 42%, #ffffff 100%)",
			}}
		>
			<Typography sx={{ color: "#64748b", fontSize: 15 }}>{message}</Typography>
		</Box>
	);
};

export default ContinuePage;
